// Sentry initialization should be imported first!
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./components/special/genie-theme/genie-theme";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './auth0-provider';
import { BrowserRouter } from "react-router-dom";

// // Only initialize Sentry if DSN is provided
// const sentry_dsn = process.env.REACT_APP_SENTRY_DSN;
// console.log("sentry_dsn", sentry_dsn);
// //TODO: add sentry
// if (sentry_dsn) {
//   Sentry.init({
//     dsn: sentry_dsn,
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true,
//     integrations: [],
//   });
// }

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
